package ru.playa.sce.dto

/**
 * @author Ермаков Игорь Александрович (email: igor.yermakov94@yandex.ru)05.10.2017.
 */
class ExternalMapping(val id: Int, val code: String, val external: Option)